import { Link } from "react-router-dom";
import Typical from "react-typical";
import About from "../about/About";
import Contact from "../contact/Contact";
import Services from "../services/Services";
import Skills from "../skills/Skills";

//work
import WorkCard from "../../Components/card/WorkCard";
import AllWork from "../../data/work.json";
import "../portfolio/portfolio.css";

import "./home.css";

export default function Home() {
  // Filter to get only 3 items with category "Development"
  const devWorks = AllWork.workItems
    .filter((work) => work.category === "Development")
    .sort((a, b) => b.id - a.id)
    .slice(0, 3);

  return (
    <>
      <div className="home">
        <div className="homeInfo" data-aos="fade-up">
          <p>Hello, my name is</p>
          <h1>Asadulla Ahmed</h1>
          <span>And I'm a </span>
          {
            <Typical
              steps={[
                "Web Designer",
                1000,
                "Freelancer",
                1000,
                "Web Developer ",
                1000,
                "MERN Stack Developer",
                1000,
              ]}
              loop={Infinity}
              wrapper="span"
            />
          }
          <Link className="link" to="/contact">
            <button className="button">Hire me</button>
          </Link>
        </div>
      </div>

      <About />
      <Services />
      <Skills />

      {/* WorkList */}
      <div className="portfolio" data-aos="fade-up">
        <div className="container">
          <div className="portfolioTitle" data-aos="fade-down">
            <h2 className="titleHead">Work List</h2>
            <p className="titleDoc"> see the task </p>
          </div>
          <div className="allworkItems">
            {devWorks.map((workItem) => (
              <WorkCard key={workItem.id} workItem={workItem} />
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link
              to="/recent-work"
              className="link button"
              style={{
                marginTop: "2rem",
                fontSize: "20px",
                padding: ".4rem 2rem",
              }}
            >
              See All
            </Link>
          </div>
        </div>
      </div>

      <Contact />
    </>
  );
}
